import React, { useEffect, useState } from "react";
import api from '../../services/api';
import Modal from 'react-modal';
import Flex from '@react-css/flex';
import Swal from "sweetalert2";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { StyledForm } from "../../styled-components/StyledForm.style";
import { SelectSimples } from "../../components/SelectSimples";

export const ModalCalendarioIndisponibilidadesAdicionar = ({ isOpen, setIsOpen, profissionaisList = [], onRequestClose }) => {
    const [isLoading, setisLoading] = useState(false);
    const [tiposIndisponibilidade, setTiposIndisponibilidade] = useState([]);
    const [indisponibilidades, setIndisponibilidades] = useState([]);

    const style = {
        content: {
            top: '50%', left: '50%', right: 'auto', bottom: 'auto',
            marginRight: '-50%', transform: 'translate(-50%, -50%)',
            borderRadius: "0px", minWidth: '65%', overflowY: 'auto', // Aumentei um pouco o minWidth para acomodar a lixeira
            minHeight: '45%', maxHeight: '90%'
        },
        overlay: { zIndex: 9999 }
    };

    const closeModal = () => {
        setisLoading(false);
        setIndisponibilidades([]); // Limpa ao fechar
        setIsOpen(false); 
        if (onRequestClose) onRequestClose();
    };

    // Busca os tipos dinâmicos da API
    const carregarTipos = async () => {
        try {
            const response = await api.get('WipFeriasAusencias/tipos');
            setTiposIndisponibilidade(response.data.data || []);
        } catch (error) {
            console.error("Erro ao carregar os tipos:", error);
            Swal.fire('Erro', 'Não foi possível carregar os tipos de indisponibilidade.', 'error');
        }
    };

    const adicionarLinhaManual = () => {
        const novaIndisponibilidade = {
            id: `indisp-${Date.now()}`,
            idProfissional: "",
            idTipo: "",
            dataInicio: null,
            dataFim: null
        };
        setIndisponibilidades([...indisponibilidades, novaIndisponibilidade]);
    };

    const removerLinhaManual = (idParaRemover) => {
        setIndisponibilidades(indisponibilidades.filter(item => item.id !== idParaRemover));
    };

    const handleInputChange = (id, field, value) => {
        setIndisponibilidades(indisponibilidades.map(item => 
            item.id === id ? { ...item, [field]: value } : item
        ));
    };

    const handleSalvar = async () => {
        if (indisponibilidades.length === 0) {
            Swal.fire('Atenção', 'Adicione pelo menos uma indisponibilidade.', 'warning');
            return;
        }

        const temLinhaInvalida = indisponibilidades.some(item => 
            !item.idProfissional || !item.idTipo || !item.dataInicio || !item.dataFim
        );

        if (temLinhaInvalida) {
            Swal.fire('Atenção', 'Preencha todos os campos de todas as linhas.', 'warning');
            return;
        }

        // Mapeia para o DTO AdicionarAusenciaDto do Backend
        const payload = indisponibilidades.map(item => ({
            idProfissional: parseInt(item.idProfissional),
            tipo: parseInt(item.idTipo),
            dataInicio: item.dataInicio.toISOString(),
            dataFim: item.dataFim.toISOString()
        }));

        setisLoading(true);
        try {
            await api.post('WipFeriasAusencias/lote', payload);
            Swal.fire('Sucesso', 'Indisponibilidades salvas com sucesso!', 'success').then(() => {
                closeModal(); 
            });
        } catch (error) {
            console.error("Erro ao salvar:", error);
            // Captura o erro customizado do backend (conflito de datas)
            const msgErro = error.response?.data?.notification?.messageReturn || 'Ocorreu um erro ao salvar as indisponibilidades.';
            Swal.fire('Erro na Validação', msgErro, 'error');
        } finally {
            setisLoading(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            carregarTipos();
            if (indisponibilidades.length === 0) {
                adicionarLinhaManual();
            }
        }
    }, [isOpen]);

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            contentLabel="Modal Adicionar Indisponibilidades"
            style={style}
            ariaHideApp={false}
        >
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="pull-left">
                                <p className="modal-title">
                                    <i className="fa fa-calendar pe-2" style={{ fontSize: '24px', color: '#EE4B21' }}></i>
                                    Adicionar Férias / Ausências
                                </p>
                            </div>
                            <div className="pull-right">
                                <p className="modal-close" onClick={closeModal}><button type="button" className="default-button-red-small px-2">X</button></p>
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>
                
                { isLoading ? (
                    <div className="text-center">
                        <div className="spinner-border ms-auto mt-2" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                        <div className="mt-2"><strong style={{ color: "#EE4B21" }}>Processando dados...</strong></div>
                    </div>
                ) : (
                    <div style={{ padding: '0 10px 20px 10px' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
                            <thead>
                                <tr style={{ borderBottom: '2px solid #ccc', textAlign: 'left' }}>
                                    <th style={{ padding: '10px', width: '35%' }}>Profissional</th>
                                    <th style={{ padding: '10px', width: '25%' }}>Tipo</th>
                                    <th style={{ padding: '10px', width: '15%' }}>Data Início</th>
                                    <th style={{ padding: '10px', width: '15%' }}>Data Fim</th>
                                    <th style={{ padding: '10px', width: '10%', textAlign: 'center' }}>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {indisponibilidades.map((item) => (
                                    <tr key={item.id} style={{ borderBottom: '1px solid #eee' }}>
                                        
                                        <td style={{ padding: '10px' }}>
                                            <SelectSimples
                                                value={item.idProfissional} 
                                                onChange={(val) => handleInputChange(item.id, 'idProfissional', val)}
                                                options={profissionaisList}
                                                keyValue="idUsuario" // Confirme se o id do profissional vem como idUsuario
                                                keyLabel="nome"
                                                placeholder="Selecione o profissional"
                                            />
                                        </td>

                                        <td style={{ padding: '10px' }}>
                                            <SelectSimples
                                                value={item.idTipo} 
                                                onChange={(val) => handleInputChange(item.id, 'idTipo', val)}
                                                options={tiposIndisponibilidade}
                                                keyValue="id"
                                                keyLabel="descricao"
                                                placeholder="Selecione o tipo"
                                            />
                                        </td>

                                        <td style={{ padding: '10px' }}>
                                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                                <DatePicker 
                                                    dateFormat="dd/MM/yyyy" locale="pt-BR" className="input-form pe-4" 
                                                    selected={item.dataInicio} selectsStart startDate={item.dataInicio} endDate={item.dataFim}
                                                    onChange={(date) => handleInputChange(item.id, 'dataInicio', date)} 
                                                    style={{ width: '100%', paddingRight: '30px' }} 
                                                />
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#999" viewBox="0 0 16 16" style={{ position: 'absolute', right: '10px', pointerEvents: 'none' }}>
                                                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                                                </svg>
                                            </div>
                                        </td>

                                        <td style={{ padding: '10px' }}>
                                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                                <DatePicker 
                                                    dateFormat="dd/MM/yyyy" locale="pt-BR" className="input-form pe-4" 
                                                    selected={item.dataFim} selectsEnd startDate={item.dataInicio} endDate={item.dataFim} minDate={item.dataInicio}
                                                    onChange={(date) => handleInputChange(item.id, 'dataFim', date)} 
                                                    style={{ width: '100%', paddingRight: '30px' }} 
                                                />
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#999" viewBox="0 0 16 16" style={{ position: 'absolute', right: '10px', pointerEvents: 'none' }}>
                                                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                                                </svg>
                                            </div>
                                        </td>

                                        {/* COLUNA: LIXEIRA */}
                                        <td style={{ padding: '10px', textAlign: 'center' }}>
                                            <button
                                                type="button"
                                                onClick={() => removerLinhaManual(item.id)}
                                                style={{ backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px 12px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px' }}
                                                title="Remover linha"
                                            >
                                                <i className="fa fa-trash" style={{ fontSize: '16px' }}></i>
                                            </button>
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <button type="button" onClick={adicionarLinhaManual} style={{ padding: '10px 15px', fontSize: '14px', cursor: 'pointer', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '4px', fontWeight: 'bold' }}>
                                + Adicionar Indisponibilidade
                            </button>

                            <button type="button" onClick={handleSalvar} style={{ padding: '10px 15px', fontSize: '14px', cursor: 'pointer', backgroundColor: '#EE4B21', color: '#fff', border: 'none', borderRadius: '4px', fontWeight: 'bold' }}>
                                Salvar Configurações
                            </button>
                        </div>
                    </div>
                )}
            </StyledForm>
        </Modal>
    );
}